export function resetApplicationScroll(root = document) {
    const scrollports = new Set([
        root.getElementById?.("main-content"),
        root.querySelector?.(".app-main-scroll"),
        root.scrollingElement,
        root.documentElement,
        root.body
    ]);

    for (const scrollport of scrollports) {
        if (!scrollport) continue;
        scrollport.scrollTop = 0;
        scrollport.scrollLeft = 0;
    }
}
